import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const AuthenticationPrompt = ({ variant = 'banner' }) => {
  const navigate = useNavigate();

  if (variant === 'banner') {
    return (
      <div className="bg-gradient-to-r from-primary to-secondary text-primary-foreground py-12 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-primary-foreground/20 rounded-xl flex items-center justify-center">
              <Icon name="ChefHat" size={36} color="var(--color-primary-foreground)" />
            </div>
          </div>
          <h2 className="text-3xl font-heading font-bold mb-4">
            Discover Authentic Home-Cooked Meals
          </h2>
          <p className="text-lg mb-8 opacity-90">
            Join our community of home chefs and food lovers. Order delicious meals or start your own cloud kitchen today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="outline"
              size="lg"
              onClick={() => navigate('/register')}
              className="bg-primary-foreground text-primary hover:bg-primary-foreground/90"
            >
              Start as a Chef
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={() => navigate('/register')}
              className="bg-primary-foreground text-primary hover:bg-primary-foreground/90"
            >
              Order Food
            </Button>
          </div>
          <button
            onClick={() => navigate('/login')}
            className="mt-6 text-primary-foreground underline hover:no-underline transition-smooth"
          >
            Already have an account? Sign in
          </button>
        </div>
      </div>
    );
  }

  if (variant === 'card') {
    return (
      <div className="bg-card rounded-xl shadow-warm p-8 max-w-md mx-auto">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center">
            <Icon name="Lock" size={36} color="var(--color-primary)" />
          </div>
        </div>
        <h3 className="text-2xl font-heading font-bold text-center mb-4">
          Sign In Required
        </h3>
        <p className="text-muted-foreground text-center mb-6">
          Please sign in to access this feature and explore our marketplace.
        </p>
        <div className="flex flex-col gap-3">
          <Button
            variant="default"
            fullWidth
            onClick={() => navigate('/login')}
          >
            Sign In
          </Button>
          <Button
            variant="outline"
            fullWidth
            onClick={() => navigate('/register')}
          >
            Create Account
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-muted rounded-lg p-6 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="UserPlus" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h4 className="font-heading font-semibold text-lg mb-1">
            Join HungryElph
          </h4>
          <p className="text-muted-foreground text-sm">
            Sign up to order meals or start your cloud kitchen
          </p>
        </div>
      </div>
      <div className="flex gap-3">
        <Button
          variant="ghost"
          onClick={() => navigate('/login')}
        >
          Sign In
        </Button>
        <Button
          variant="default"
          onClick={() => navigate('/register')}
        >
          Get Started
        </Button>
      </div>
    </div>
  );
};

export default AuthenticationPrompt;